import axios from "../../config/axiosConfig";
import { GET_ACCOUNT_ITEM_RATES, ACCOUNT_ITEM_RATE_REQUEST, CREATE_ACCOUNT_ITEM_RATE, UPDATE_ACCOUNT_ITEM_RATE, ACCOUNT_ITEM_RATE_REQUEST_FAILURE } from "../types";

export const getAccountItemRates = (type, refId) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: ACCOUNT_ITEM_RATE_REQUEST });
      const { auth } = getState();
      let params = { customerId: auth?.user?.Customer_Id };
      if (!auth?.company?.Common_Master) {
        params = { ...params, companyId: auth.company?.id }
      }
    //   console.log('include>>', include);
      
      if (type && refId) {
        params = { ...params, type, refId, companyId: auth.company?.id };
      }
      return axios.get("/account-item-rate/get", { params }).then((response) => {
        if (response.data) {
            return response.data;
          dispatch({ type: GET_ACCOUNT_ITEM_RATES, payload: response?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ACCOUNT_ITEM_RATE_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: ACCOUNT_ITEM_RATE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const saveAccountItemRates = (include) => {
  return async (dispatch, getState) => {
    try {
        dispatch({ type: ACCOUNT_ITEM_RATE_REQUEST });
      const { auth } = getState();
      let data = { ...include, customerId: auth?.user?.Customer_Id, companyId: auth.company?.id };
      // if (include) {
      //   data = { ...data, include };
      // }
      return axios.post("/account-item-rate/save", data ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_ACCOUNT_ITEM_RATE, payload: response?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: ACCOUNT_ITEM_RATE_REQUEST_FAILURE, error: error.message });
      });
    } catch (error) {
        console.error(error);
        dispatch({ type: ACCOUNT_ITEM_RATE_REQUEST_FAILURE, error: error.message });
    }
  }
}

export const getPartyItemWiseRateByMaster = (accountId, itemId) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        companyId: auth.company?.id,
        customerId: auth?.customer?.id,
        accountId, itemId
      };
      const response = await axios.get("/account-item-rate/get-party-item-wise-rate", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};